module.exports = __webpack_public_path__ + "app/core/bo-user/bo-user-list-10oZrEn1.html";